import React from 'react';
import ServiceWidget from './Services';
import './Education.css';

function Education() {
    return (
        <section className="edu-section" id="resume">
            <div className="edu-inner">

                {/* ── کارت دکتر سیمین ── */}
                <div className="edu-doctor">
                    <span className="edu-doctor__badge">مشاور تخصصی</span>
                    <h3 className="edu-doctor__name">دکتر سیمین</h3>
                    <p className="edu-doctor__tagline">ایده، تولید، بازاریابی<br />گام به گام همراه با شما</p>
                    <div className="edu-doctor__divider" />
                    <p className="edu-doctor__desc">
                        اگر به دنبال قرارداد مشاوره آرایشی و بهداشتی هستید، بهتر است با یک متخصص در این حوزه تماس بگیرید یا به کارشناسان مربوطه مراجعه کنید.
                    </p>
                    <p className="edu-doctor__desc" style={{ marginTop: '12px' }}>
                        آیا نیاز به راهنمایی برای پیدا کردن منبع مناسب دارید؟
                    </p>
                </div>

                {/* ── آکاردئون خدمات ── */}
                <div className="edu-services">
                    <h3 className="edu-services__title">خدمات ما</h3>
                    <ServiceWidget />
                </div>

            </div>
        </section>
    );
}

export default Education;
